import { Fragment } from "react"
import frames from "../images/collection.webp"
import handmade from "../images/handmadepic.jpg"
import potraitarts from "../images/art.jpg"
import { useNavigate } from "react-router-dom"
import bestseller from "../images/bestseller.webp"


const Collection = () => {
    const Navigate = useNavigate();
    return (
        <Fragment>
            <div className="container mt-4">
                <h1>Collections</h1>
                <div className="frames">
                    <div class="card" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/frames")
                    }}>
                        <img src={frames} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Frames</i></h6>


                        </div>
                    </div>
                    <div class="card" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/handmade-gifts")
                    }}>
                        <img src={handmade} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Handmade Gifts</i></h6>


                        </div>
                    </div>

                    <div class="card" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/potrait-arts")
                    }}>
                        <img src={potraitarts} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Arts and paintings</i></h6>


                        </div>
                    </div>
                    <div class="card" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/bestseller")
                    }}>
                        <img src={bestseller} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Best-seller</i></h6>


                        </div>
                    </div>
                </div>

            </div>
        </Fragment>
    )




}
export default Collection;